import React from 'react';
import { ProgressStages } from './ProgressStages';
import type { GenerationStage } from '../types/disclosures';
interface GeneratingCardProps {
  stages: GenerationStage[];
  pairLabel: string;
}
export function GeneratingCard({
  stages,
  pairLabel
}: GeneratingCardProps) {
  const completed = stages.filter(stage => stage.state === 'done').length;
  const percent = Math.round((completed + 0.5) / Math.max(stages.length, 1) * 100);
  return <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-card" data-id="element-131" data-mp="r6doclppvhpc">
      <h2 className="text-[16px] font-semibold tracking-[-0.01em] text-slate-900" data-id="element-132" data-mp="m8lydx8mu5ns">
        Generating Initial Disclosures
      </h2>
      <p className="mt-1 text-[13px] text-slate-500" data-id="element-133" data-mp="10xqkhpijsu16">{pairLabel}</p>

      <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-slate-100" data-id="element-134" data-mp="w3mcd2xjqfyi">
        <div className="h-full rounded-full bg-blue-600 transition-all duration-700 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-135" data-mp="8ebgnzv1zbr8" />
      </div>

      <div className="mt-5" data-id="element-136" data-mp="qmm0ngpseeko">
        <ProgressStages stages={stages} data-id="element-137" data-mp="qlawvgwcd6tk" />
      </div>

      <p className="mt-5 text-[13px] text-slate-500" data-id="element-138" data-mp="vl6zpctays7j">This normally completes shortly.</p>
    </section>;
}